<template>
  <div class="map" style="height: 200px; width: 100%">
    <l-map
      :zoom="9"
      :maxZoom="15"
      :minZoom="6"
      :center="[latitude, longitude]"
    >
      <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
      <l-circle :lat-lng="[latitude, longitude]" :radius="2000" color="green" />
    </l-map>
  </div>
</template>

<script>
import { LMap, LTileLayer, LCircle } from "vue2-leaflet";
import { mapMutations, mapState } from "vuex";

export default {
  name: "TopicZipcodeLocation",
  props: ["latitude", "longitude"],
  data() {
    return {
      url: "http://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
    };
  },
  computed: {
    ...mapState(["theme"])
  },
  watch: {
    theme: function() {
      this.changeMapBaseUrlBasedOnTheme();
    }
  },
  components: {
    LMap,
    LTileLayer,
    LCircle
  },
  mounted() {
    this.changeMapBaseUrlBasedOnTheme();
  },
  methods: {
    ...mapMutations(["setTheme"]),
    changeMapBaseUrlBasedOnTheme: function() {
      if (this.theme === "dark") {
        this.url = "http://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png";
        // this.attribution = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
      } else {
        this.url = "http://{s}.tile.osm.org/{z}/{x}/{y}.png";
        // this.attribution = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
      }
    }
  }
};
</script>
